<template>
<div class="chapter">
<div class="inner_page">
<p class="ctl" id="d12e267"><a href="#/Wals_ISBN1418537640_epub_c4_r1#d12e116" id="d12e268">acknowledgments</a></p>
<p class="tx1" id="d12e270">All my most memorable trips have been shared with a friend or a loved one. Writing this book has been no exception.</p>
<p class="tx" id="d12e272">I am deeply grateful to Leslie Peterson, who has walked this editorial path with me every step of the way. Your grace and patience touched me deeply, and your sense of humor carried me when I was about to shave my head!</p>
<p class="tx" id="d12e274">Jennifer Stair took our offering and lovingly groomed and trimmed it so that even if it won’t win Best in Show, it can wag its tail with the best of them.</p>
<p class="tx" id="d12e276">Bryan Norman, you are my new hero. Your editorial suggestions, questions, wisdom, and encouragement have impacted me deeply. Thank you!</p>
<p class="tx" id="d12e278">Brian Hampton and the whole Thomas Nelson team make it pure joy to follow the call of a writer. I consider it a great honor to be part of your family.</p>
<p class="tx" id="d12e280">Tami Heim, you are a brilliant leader and treasured friend!</p>
<p class="tx" id="d12e282">Mary Graham and my “porch pals” at Women of Faith—you are my fellow road warriors as we take the life-changing news of the love of God to a wounded world. I love you all.</p>
<p class="tx" id="d12e284">I want to thank my husband, Barry, and son, Christian, for their grace, patience, and understanding of the writing process and for providing me with <i>so </i>much material!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wals_ISBN1418537640_epub_c5_r1.vue?57617a08